// Global toast. CLAUDE.md §3.3 (K-UI kuralı): metin DAİMA yan etkiyi söyler —
// "Kaydedildi" değil, "LOT-2026-0463 · havuz +23,8 t · HAO güncellendi".

import { useEffect, useState } from 'react'

type Dinleyici = (mesaj: string) => void

let dinleyici: Dinleyici | null = null

/** Ekranların çağırdığı tek giriş noktası. */
export function toast(mesaj: string) {
  dinleyici?.(mesaj)
}

export function ToastYuvasi() {
  const [mesaj, setMesaj] = useState<string | null>(null)

  useEffect(() => {
    dinleyici = (m) => setMesaj(m)
    return () => {
      dinleyici = null
    }
  }, [])

  useEffect(() => {
    if (mesaj === null) return
    // Referans showToast() 3200 ms tutuyor.
    const zamanlayici = setTimeout(() => setMesaj(null), 3200)
    return () => clearTimeout(zamanlayici)
  }, [mesaj])

  return (
    <div className={mesaj ? 'toast on' : 'toast'}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 6 9 17l-5-5" />
      </svg>
      <span>{mesaj}</span>
    </div>
  )
}
